var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.webstoreContent
    ? _c(
        "div",
        { attrs: { id: "accessories-page" } },
        [
          _c("ProductSubNav", {
            attrs: {
              globals: _vm.webstoreContent.webstoreBody,
              isSticky: _vm.productNavIsSticky,
            },
          }),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              {
                staticClass: "row section-margin",
                attrs: { id: "product-content-container" },
              },
              [
                _c(
                  "div",
                  { staticClass: "md:w-5/12", attrs: { id: "product-image" } },
                  [
                    _c("img", {
                      attrs: {
                        alt: _vm.activeProductInfo.name,
                        src: _vm.activeOffer.offerImage,
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "roboto md:w-6/12",
                    attrs: { id: "product-info" },
                  },
                  [
                    _c("div", { staticClass: "info-wrapper" }, [
                      _c(
                        "div",
                        [
                          _c(
                            "h3",
                            {
                              staticClass: "mb-0",
                              attrs: { id: "product-name" },
                            },
                            [_vm._v(_vm._s(_vm.activeProductInfo.name))]
                          ),
                          _vm._v(" "),
                          _vm.shouldCustomerSeePricing
                            ? _c("Pricing", { attrs: { accessories: true } })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.hasContractExpired &&
                      _vm.showContractDisclaimer &&
                      _vm.hasLicenseOffer
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "mb-0 mt-1 text-lg bold leading-tight",
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.contractDisclaimer) +
                                    "\n            "
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeProductInfo.info
                        ? _c("div", { staticClass: "section-margin-2" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-xl font-normal text-blue-dark",
                                class:
                                  _vm.activeOffer.productStatus ===
                                    "Out of stock" && "out-of-stock",
                              },
                              [_vm._v(_vm._s(_vm.activeProductInfo.info))]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeProductInfo.compatibleWith &&
                      _vm.activeProductInfo.compatibleWith.length > 0
                        ? _c(
                            "div",
                            { staticClass: "section-margin-2" },
                            [
                              _c(
                                "div",
                                { staticClass: "product-body-section-headers" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.webstoreContent.accessoriesPage
                                        .sectionTitles.compatibility
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.activeProductInfo.compatibleWith,
                                function (bullet) {
                                  return _c(
                                    "ul",
                                    {
                                      key: bullet,
                                      attrs: { id: "offer-included-list" },
                                    },
                                    [
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "cursor-pointer list-disc text-lg",
                                          on: {
                                            click: function ($event) {
                                              return _vm.navigateToProduct(
                                                bullet.productKey,
                                                bullet.productFamily
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(bullet.productName) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeProductInfo.goodToKnow
                        ? _c("div", { staticClass: "section-margin-2 !mb-4" }, [
                            _c(
                              "div",
                              { staticClass: "product-body-section-headers" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.webstoreContent.accessoriesPage
                                        .sectionTitles.goodToKnow
                                    )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-lg" }, [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.activeProductInfo.goodToKnow)
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.activeProductInfo.installationGuide
                        ? _c("div", { staticClass: "section-margin-2 !mb-4" }, [
                            _c("div", { staticClass: "text-lg" }, [
                              _c("a", { attrs: { href: "" } }, [
                                _vm._v("Download install guide"),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.cablePage
                        ? _c("div", [
                            _vm.activeProductInfo.accessorySpecs &&
                            _vm.activeProductInfo.accessorySpecs.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "specs-section" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "cursor-pointer",
                                        attrs: {
                                          id: "product-body-specs-header",
                                        },
                                        on: { click: _vm.toggleSpecs },
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.webstoreContent
                                                .accessoriesPage.sectionTitles
                                                .specs
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "cursor-pointer mb-0",
                                            attrs: { id: "plus-button" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.specsClicked ? "-" : "+"
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "SlideUpDown",
                                      {
                                        staticClass: "accordion mt-0",
                                        attrs: { active: _vm.specsClicked },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "accordion-content" },
                                          [
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "list-disc ml-1 mt-2",
                                              },
                                              _vm._l(
                                                _vm.activeProductInfo
                                                  .accessorySpecs,
                                                function (spec, index) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: spec,
                                                      staticClass:
                                                        "text-xl dark-blue-text",
                                                      class:
                                                        index !==
                                                          _vm.activeProductInfo
                                                            .accessorySpecs
                                                            .length -
                                                            1 && "mb-1/2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(spec) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                class:
                                  _vm.activeOffer.productStatus ===
                                    "Out of stock" && "grayed",
                              },
                              [
                                _vm.anonymousLargeFleet ||
                                (_vm.isENT &&
                                  _vm.activeOffer &&
                                  !_vm.activeOffer.monthlyUnitPrice)
                                  ? [
                                      _c(
                                        "div",
                                        [
                                          _c("vButton", {
                                            staticClass: "add-to-bag",
                                            attrs: {
                                              position: "center",
                                              mobile: "12",
                                              tablet: "12",
                                              desktop: "12",
                                              styling: "primary rounded",
                                            },
                                            on: {
                                              onClickEvent: function ($event) {
                                                _vm.anonymousLargeFleet
                                                  ? _vm.$emit(
                                                      "anonymous-inquiry"
                                                    )
                                                  : (_vm.inquireModalIsOpen = true)
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "content",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        "\n                      Inquire\n                    "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              3696025993
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : Object.keys(_vm.activeProductInfo.offerings)
                                      .length > 1 &&
                                    (!_vm.isENT ||
                                      (_vm.isENT &&
                                        _vm.activeOffer &&
                                        _vm.activeOffer.monthlyUnitPrice))
                                  ? [
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "h3",
                                            {
                                              staticClass:
                                                "bold text-blue-dark md:mt-4",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    [
                                                      "ACC-PR",
                                                      "ACC-PB",
                                                      "ACC-AUX",
                                                      "ACC-CIG-LIGHT",
                                                    ].includes(
                                                      _vm.activeProductKey
                                                    )
                                                      ? "Are you looking for B-class or C-class?"
                                                      : _vm.webstoreContent
                                                          .cartPage
                                                          .choose_license
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          [
                                            "ACC-PR",
                                            "ACC-PB",
                                            "ACC-AUX",
                                            "ACC-CIG-LIGHT",
                                          ].includes(_vm.activeProductKey)
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "mt-0 mb-0",
                                                  attrs: {
                                                    href: "https://downloads.ctfassets.net/bx9krvy0u3sx/3HmMci5BzpI9nrLsOtJWxg/68e689e65c3132fcf2b9126e9eba0b7b/cable_guide.pdf",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Unsure? See instructions to identify the class"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("LicenseSelection", {
                                            attrs: { accessories: true },
                                            on: { "scroll-to": _vm.scrollTo },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { ref: "quantity" }, [
                                  _vm.shouldCustomerSeePricing &&
                                  (_vm.activeOfferKey ||
                                    Object.keys(_vm.activeProductInfo.offerings)
                                      .length === 1)
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "h3",
                                            {
                                              staticClass:
                                                "bold text-blue-dark mt-4 mb-0",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.webstoreContent.cartPage
                                                      .quantityCopy
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            this.activeProductInfo.offerings,
                                            function (offer_info, offer) {
                                              return _c(
                                                "div",
                                                {
                                                  key: offer,
                                                  staticClass:
                                                    "quantity-section",
                                                },
                                                [
                                                  (
                                                    Object.keys(
                                                      _vm.activeProductInfo
                                                        .offerings
                                                    ).length > 1
                                                      ? _vm.activeOfferKey &&
                                                        offer_info.offerKey ===
                                                          _vm.activeOfferKey
                                                      : true
                                                  )
                                                    ? _c("ProductQuantity", {
                                                        ref: _vm.cleanOfferKey(
                                                          offer_info.offerKey
                                                        ),
                                                        refInFor: true,
                                                        attrs: {
                                                          type: "product",
                                                          showImage: false,
                                                          updateTotal: true,
                                                          imageSource:
                                                            offer_info.offerImage,
                                                          productName:
                                                            _vm
                                                              .activeProductInfo
                                                              .name,
                                                          skuText:
                                                            offer_info.productCodes.join(
                                                              ", "
                                                            ),
                                                          salesPrice:
                                                            _vm
                                                              .activeProductInfo
                                                              .offerings[offer]
                                                              .salesPrice,
                                                          defaultTerm:
                                                            _vm.activeOffer
                                                              .defaultPaymentTerm,
                                                          cablesRequired:
                                                            _vm.doesOfferRequireCable(
                                                              _vm.activeOfferKey
                                                            ),
                                                          currency:
                                                            _vm.currencySymbol,
                                                          maxPurchasableQuantity:
                                                            offer_info.maxPurchasableQuantity,
                                                          minPurchasableQuantity: 1,
                                                          startingNumber:
                                                            _vm.setInitialOfferQuantity(
                                                              offer_info
                                                            ),
                                                          value: `${offer} Quantity`,
                                                          maxError:
                                                            _vm.webstoreContent
                                                              .cartPage
                                                              .max_quantity_error,
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _c("vButton", {
                                            staticClass: "add-to-bag",
                                            attrs: {
                                              position: "center",
                                              mobile: "12",
                                              tablet: "12",
                                              desktop: "12",
                                              styling: "primary rounded",
                                            },
                                            on: {
                                              onClickEvent:
                                                _vm.cartUpdateHandler,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "content",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        "\n                      Add To Bag\n                    "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              1560512842
                                            ),
                                          }),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ]),
                              ],
                              2
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.cablePage
                      ? _c(
                          "div",
                          { staticClass: "mb-5" },
                          [
                            _c("CableQuestion", {
                              attrs: {
                                webstoreContent: _vm.webstoreContent,
                                selectedTypeOfReplacementCable:
                                  _vm.selectedTypeOfReplacementCable,
                                isVGCable: _vm.isVGCable,
                              },
                              on: {
                                "set-selected-cable-type":
                                  _vm.setTypeOfReplacementCable,
                              },
                            }),
                            _vm._v(" "),
                            !_vm.onlyOneCableSelectionMethod
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "section-margin-2 product-body-section-headers cable-selection",
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.webstoreContent.accessoriesPage
                                            .sectionTitles.cableSelectionMethod
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("CableSelection", {
                              ref: "cable-selection",
                              attrs: {
                                correspondingProduct: _vm.getProduct(),
                                isCableAccessoriesPage: true,
                                activeCableSelectionMethods:
                                  _vm.activeCableSelectionMethods,
                                addToCart: false,
                                selectedTypeOfReplacementCable:
                                  _vm.selectedTypeOfReplacementCable,
                              },
                              on: {
                                "scroll-to": _vm.scrollToCableSelect,
                                "add-selection-method":
                                  _vm.updateActiveCableSelectionMethods,
                                "remove-selection-method":
                                  _vm.removeActiveCableMethod,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.activeProductInfo.frequentlyBoughtTogether &&
          _vm.activeProductInfo.frequentlyBoughtTogether.length > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "md:mt-5 col xs-12 sm-12 lg-12 roboto accessories-carousel",
                },
                [
                  _c(
                    "div",
                    { attrs: { id: "accessories-carousel-messaging" } },
                    [
                      _c(
                        "div",
                        { attrs: { id: "accessories-carousel-header" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.webstoreContent.accessoriesPage
                                  .sectionTitles.moreAccessoriesMessaging
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.webstoreContent.accessoriesPage
                                .moreAccessoriesMessaging
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("FrequentlyBoughtTogether", {
                    attrs: {
                      isAccessories: true,
                      activeProductInfo: _vm.activeProductInfo,
                    },
                  }),
                ],
                1
              )
            : _c("div", { staticClass: "mb-5" }),
          _vm._v(" "),
          _c("ActionBottomNav", {
            ref: "bottom-nav",
            attrs: {
              submitButtonText: _vm.submitButtonText,
              activeCableSelectionMethods: _vm.activeCableSelectionMethods,
              bottomNavIsShown: _vm.bottomNavIsShown,
              isCableAccessoriesPage: true,
            },
            on: {
              "scroll-to": _vm.scrollTo,
              "add-selection-method": _vm.updateActiveCableSelectionMethods,
              "add-to-cart": _vm.addToCartCables,
              "anonymous-inquiry": function ($event) {
                return _vm.$emit("anonymous-inquiry")
              },
            },
          }),
          _vm._v(" "),
          _c("InquireModal", {
            attrs: { isOpen: _vm.inquireModalIsOpen },
            on: {
              "hide-modal": function ($event) {
                _vm.inquireModalIsOpen = false
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }